import { autoRegisterFeature } from '@store/features/factory';

import { patientCoveragesFeature } from './store/feature';

// Auto-register the feature
autoRegisterFeature(patientCoveragesFeature);

// Export everything from store
export * from './store';

// Export types
export * from './types';

// Export components
export { BillingTab } from './components/BillingTab/BillingTab';
export { EligibilityCheckCard } from './components/EligibilityCheckCard';
export { EligibilityStatusIcon } from './components/EligibilityStatusIcon';

// Export eligibility status config utilities
export type { StatusConfig } from './components/BillingTab/eligibilityStatusConfig';
export { formatAlertLabel, getAlertGuidance, STATUS_CONFIG } from './components/BillingTab/eligibilityStatusConfig';

// Export hooks
export { useEligibilityCardState } from './hooks/useEligibilityCardState';
export { usePatientEligibilityStatus } from './hooks/usePatientEligibilityStatus';
